export enum RequestStatus {
  Approve = 'Approved',
  Decline = 'Declined',
  Cancel = 'Cancel',
  New = 'New',
  InProcess = 'InProcess',
}
